/* Palmr Matching Sets — add-the-set cart logic, set-count meter, CTA scroll pulse.
   Loaded once with defer; initializes every instance on the page.
   Extracted from the section's inline <script>; the set handles travel via
   data-pms-handles on the meter element. */
(function () {
  function initMs(root) {
    if (!root || root.dataset.palmrMsInit) return;
    root.dataset.palmrMsInit = 'true';

    var meter = root.querySelector('[data-pms-meter]');
    var msgEl = root.querySelector('[data-pms-meter-msg]');
    var checkoutEl = root.querySelector('[data-pms-checkout]');
    if (!meter || !msgEl) return;

    var SET = (meter.getAttribute('data-pms-handles') || '').split(',').filter(Boolean);
    var M = {
      empty: meter.getAttribute('data-msg-empty'),
      active: meter.getAttribute('data-msg-active')
    };

    function render(count) {
      if (count >= 1) {
        msgEl.innerHTML = (M.active || '').replace(/\{count\}/g, count);
        if (checkoutEl) checkoutEl.hidden = false;
      } else {
        msgEl.innerHTML = M.empty;
        if (checkoutEl) checkoutEl.hidden = true;
      }
    }

    function refresh() {
      fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var n = 0;
          (cart.items || []).forEach(function (it) {
            if (SET.indexOf(it.handle) !== -1) n += (it.quantity || 0);
          });
          render(n);
        })
        .catch(function () {});
    }

    function addSet(btn, items) {
      btn.setAttribute('disabled', '');
      var prev = btn.textContent;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          document.dispatchEvent(new CustomEvent('on:cart:add', { detail: { item: data } }));
          if (window.PalmrCartDrawer && window.PalmrCartDrawer.open) window.PalmrCartDrawer.open();
          btn.removeAttribute('disabled');
          btn.textContent = 'Added ✓';
          setTimeout(function () { btn.textContent = prev; }, 1600);
          refresh();
        })
        .catch(function () {
          btn.removeAttribute('disabled');
          btn.textContent = prev;
        });
    }

    root.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('[data-pms-add]');
      if (!btn || btn.hasAttribute('disabled')) return;
      e.preventDefault();
      var set = btn.closest('[data-pms-set]');
      if (!set) return;
      var m = set.querySelector('select[data-pms-role="mens"]');
      var k = set.querySelector('select[data-pms-role="kids"]');
      var items = [];
      if (m && m.value) items.push({ id: parseInt(m.value, 10), quantity: 1 });
      if (k && k.value) items.push({ id: parseInt(k.value, 10), quantity: 1 });
      if (items.length < 2) return;
      addSet(btn, items);
    });

    document.addEventListener('on:cart:add', refresh);
    document.addEventListener('on:cart:change', refresh);
    document.addEventListener('on:line-item:change', refresh);
    refresh();

    // Smooth-scroll + heading pulse for hero CTA and deal boxes — kills
    // "click did nothing" perception when the sets grid is already in view.
    function pulseBuilder() {
      var h = root.querySelector('.pms__builder-heading');
      if (!h) return;
      h.classList.remove('pms__pulse');
      void h.offsetWidth;
      h.classList.add('pms__pulse');
      setTimeout(function () { h.classList.remove('pms__pulse'); }, 900);
    }
    root.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('a[href="#shop-the-sets"]');
      if (!a) return;
      var target = document.getElementById('shop-the-sets');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setTimeout(pulseBuilder, 350);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[id^="palmr-ms-"]').forEach(initMs);
  }

  initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
